import { alpha, Box, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { Constants } from "../../utils/constants";
import { DefaultButton } from "..";


export default function ProjectScriptModal({
    open,
    onClose,
    script,
}) {

    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 300,
        maxWidth: 450,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[currentMode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-project-script-title"
            aria-describedby="modal-project-script-description"
        >
            <Box sx={style}>
                <Typography
                    sx={{
                        fontSize: Constants.Styles.fontSize.lg,
                        lineHeight: Constants.Styles.lineHeight.lg,
                        fontWeight: Constants.Styles.fontWeight.normal,
                    }}
                >
                    {`Paste this code in the <head> section of your 404 Page Template`}
                </Typography>

                <Box
                    sx={{
                        border: `1px solid ${Constants.Colors[currentMode].border}`,
                        padding: "1rem",
                        borderRadius: 2,
                        backgroundColor: alpha(Constants.Colors[currentMode].secondary, 0.5),
                        position: "relative",
                        mt: "1rem",
                    }}
                >
                    <Typography variant="body1">{script}</Typography>
                    <Box sx={{
                        position: "absolute",
                        top: "1rem",
                        right: "0.5rem",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "4px",
                        "&:hover": {
                            backgroundColor: Constants.Colors[currentMode].success,
                        },
                        padding: "3px",
                        cursor: "pointer",
                    }} onClick={() => {
                        navigator?.clipboard?.writeText(script).then(function () {
                            console.log("Script copied to clipboard");
                        }, function (err) {
                            console.error("Error copying script to clipboard:", err);
                        });
                    }}>
                        <ContentCopyOutlinedIcon sx={{

                            fontSize: 20,
                            color: Constants.Colors[currentMode].mutedForeground,
                        }} />
                    </Box>
                </Box>
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"flex-end"}
                    sx={{
                        mt: "1rem",
                    }}
                >
                    <DefaultButton
                        text={"Close"}
                        size="small"
                        onClick={onClose}
                        fullWidth={false}
                    />
                </Stack>
            </Box>

        </Modal>
    );

}